import { memo, FC } from 'react';
import classes from './Point.module.scss';
import { useTranslation,Trans } from 'react-i18next';

import { BubbleBase } from "../../../common/BubbleBase";

interface Props {
  className?: string;
  point?: string;
  classes?: {
    root?: string;
  };
}


export const Point3_1: FC<Props> = memo(function Point3_1(props) {
  const { t } = useTranslation();

  return (
    <div className={classes.slideContent}>
    <div className={classes.circleBubble}>
      <BubbleBase className={classes.circleBubbleBase} />
      <div className={classes.circleBubbleBaseText}>
        <span className={classes.circleBubbleBaseSmallText}>{t('about:point.03.part1.Bubble').split('</span>')[0]}</span>
          {t('about:point.03.part1.Bubble').split('</span>')[1]}
      </div>
    </div>
    <div className={classes.questionBlock}>
      <h4 className={classes.questionTitle}>{t('about:point.03.part1.questionTitle01')}</h4>
      <div className={`${classes.questionAnswer} ${classes.per93}`}>93%</div>
    </div>
    <div className={classes.questionBlock}>
      <h4 className={classes.questionTitle}>{t('about:point.03.part1.questionTitle02')}</h4>
      <div className={`${classes.questionAnswer} ${classes.per84}`}>84%</div>
      <ul className={classes.colorList}>
        <li className={`${classes.colorItem} ${classes.yes}`}>{t('about:point.03.part1.yes')}</li>
        <li className={`${classes.colorItem} ${classes.no}`}>{t('about:point.03.part1.no')}</li>
      </ul>
    </div>
    <small className='sponly'>{t('about:point.03.part2.amendment')}</small>
  </div>
  
  );
});

